import React, { useEffect, useContext } from 'react'
import { observer } from 'mobx-react'
import { useLocation, useHistory } from 'react-router'
import { ChevronLeftIcon } from '@heroicons/react/outline'
import { topBarStore } from '../../../lib/stores/TopBarStore'
import { caseDetailUrl, caseSuccessUrl } from '../../routing/paths'
import StoreContext from '../../providers/storesContext'
import { Link } from 'react-router-dom'
import CaseCheckoutCreditCard from './CaseCheckoutCreditCard'
import CaseCheckoutCash from './CaseCheckoutCash'

const CaseCheckout = () => {
  const location = useLocation()
  const history = useHistory()
  const { caseDetailStore } = useContext(StoreContext)
  const { immobilizationCase } = caseDetailStore

  useEffect(() => {
    if (immobilizationCase.isPaid) {
      history.push(caseSuccessUrl(immobilizationCase))
    }

    if (!caseDetailStore.immobilizationCase.isTowed) {
      if (!caseDetailStore.selectedReleaseMethod) {
        if (location?.state?.releaseMethod) {
          caseDetailStore.selectReleaseMethod(location.state.releaseMethod)
        } else {
          history.push(caseDetailUrl(immobilizationCase))
        }
      }

      if (!caseDetailStore.selectedPaymentMethod) {
        if (location?.state?.paymentMethod) {
          caseDetailStore.selectPaymentMethod(location.state.paymentMethod)
        } else {
          history.push(caseDetailUrl(immobilizationCase))
        }
      }
    }

    topBarStore.setTitle('Checkout')
  }, [])

  if (caseDetailStore.isCashPayment) {
    return <CaseCheckoutCash />
  }

  return <CaseCheckoutCreditCard />
}

export default observer(CaseCheckout)
